import { IValidation } from "./";

const Validation: IValidation = {
  error: "Por favor, digite um CEP válido",
  validate: (input: string) => /^\d{5}-?\d{3}$/.test(input),
};

export default Validation;
